var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcVendor7Eleven(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.6407 45.9258C43.4592 45.9258 44.1868 46.6534 44.1868 47.4719C44.1868 48.2904 43.5502 49.018 42.6407 49.018C41.8222 49.018 41.1855 48.2904 41.1855 47.4719C41.1855 46.6534 41.8222 45.9258 42.6407 45.9258ZM42.6407 48.6542C43.2773 48.6542 43.823 48.1085 43.823 47.4719C43.823 46.7443 43.2773 46.2896 42.6407 46.2896C42.0041 46.2896 41.4584 46.8353 41.4584 47.4719C41.4584 48.1995 42.0041 48.6542 42.6407 48.6542ZM42.4588 48.2904H42.186V46.6534H42.7316C43.0954 46.6534 43.2773 46.8353 43.2773 47.199C43.2773 47.4719 43.0954 47.6538 42.9135 47.6538L43.2773 48.2904H42.9135L42.5498 47.6538H42.4588V48.2904ZM42.6407 47.3809C42.8226 47.3809 42.9135 47.29 42.9135 47.1081C42.9135 46.9262 42.8226 46.8353 42.6407 46.8353H42.4588V47.29H42.6407V47.3809Z",
    fill: "#147350"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9164 34.377C49.0979 34.377 48.5522 34.7407 48.0065 35.1955L47.6427 35.7412L47.5518 35.6502L48.0065 34.9226V34.4679H45.0962V44.1083H47.7336V38.0148C47.7336 37.0144 48.3703 36.7416 48.825 36.6506C49.2797 36.5597 49.8254 36.8325 49.8254 37.3782V44.1083H52.4629V37.4692C52.4629 35.3774 51.5534 34.377 49.9164 34.377Z",
    fill: "#147350"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5405 41.9255H23.2689V44.0173H17.9031V34.377H20.5405V41.9255Z",
    fill: "#147350"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5369 44.0173H16.9027V42.1074H14.1743V40.0157H16.9027V38.1967H14.1743V36.3778H16.9027V34.377H11.5369V44.0173Z",
    fill: "#147350"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1785 44.0173H29.6353V42.1074H26.8159V40.0157H29.6353V38.1967H26.8159V36.3778H29.6353V34.377H24.1785V44.0173Z",
    fill: "#147350"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7297 44.0173H44.1866V42.1074H41.3672V40.0157H44.1866V38.1967H41.3672V36.3778H44.1866V34.377H38.7297V44.0173Z",
    fill: "#147350"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2739 34.377L34.2735 40.4704L34.1826 41.5618V41.6527H34.0916V41.5618L34.0007 40.4704L33.0003 34.377H30.3628L32.5455 44.0173H35.8196L38.0023 34.377H35.2739Z",
    fill: "#147350"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8239 5H11.5369V18.642H29.6353C33.7279 12.7305 39.2757 8.00125 45.8239 5Z",
    fill: "#FF6C00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.179 59.479H38.821V45.8369H25.179V59.479Z",
    fill: "#EB0F2A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4631 18.642V5C39.4577 8.54693 29.2716 19.0058 26.1794 32.2841H40.0943C42.1861 26.1906 46.7334 21.2795 52.4631 18.642Z",
    fill: "#EB0F2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVendor7Eleven);
export default __webpack_public_path__ + "static/media/ic-vendor-7eleven.a1139481935a8a5be6657d8350ab31ad.svg";
export { ForwardRef as ReactComponent };